export default __webpack_public_path__ + "static/media/logo_cfi_grey_p.dbda5223.svg";